import Swal from 'sweetalert2'

class SweetAlert {
    constructor() {

    }
    alertFire = (options) => Swal.fire(options)

}

export default SweetAlert